module.exports = __webpack_public_path__ + "img/crown.df70707a.svg";